import React from "react";
import SearchableSelect from "../searchableSelect/SearchableSelect";
import SearchField from "components/common/customSearchField/CustomSearchField";
import SortingOrder from "../sortingOrder/SortingOrder";
import ParentBtn from "../parentButton/ParentButton";
import ClearFiltersIcon from "assets/icons/ClearFiltersIcon";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "components/common/tableFilters/ActionBar.scss";
import { getIcon } from "common/constants/constants";
import { useTranslation } from "react-i18next";
function ActionBar(props) {
  const {
    orderByList,
    text,
    path,
    filters,
    productList,
    handleChange,
    searchPlaceholder,
    resetFilters,
    showAddButton,
    show,
  } = props;
  const { t } = useTranslation();
  return (
    <Container>
      <Row>
        <Col
          lg={1}
          // sm={5}
          xs={12}
          className="d-flex flex-md-column align-items-center  justify-content-md-center justify-content-around align-item-center flex-row"
        >
          {filters?.orderBy ? (
            <SortingOrder
              handleChange={handleChange}
              value={filters.orderType}
            />
          ) : (
            <div
              style={{
                pointerEvents: "none",
                opacity: 0.4,
              }}
            >
              <SortingOrder
                handleChange={handleChange}
                value={filters.orderType}
              />
            </div>
          )}
          {Object?.values(filters).some(
            (el) => el !== "DESC" && el.length > 0
          ) && <ClearFiltersIcon resetFilters={resetFilters} />}
        </Col>
        <Col lg={3} xs={12}>
          <SearchField
            name="searchString"
            placeholder={searchPlaceholder}
            value={filters.searchString}
            {...props}
          />
        </Col>
        <Col lg={3} xs={12}>
          <SearchableSelect
            name="orderBy"
            placeholder={t("sort-by")}
            options={orderByList?.map((el) => {
              return { value: el.value, label: el.name };
            })}
            value={filters.orderBy}
            handleChange={handleChange}
          />
        </Col>
        {productList && (
          <Col lg={3} xs={12}>
            <SearchableSelect
              placeholder={t("all-products")}
              name="products"
              options={productList?.map((el) => {
                return {
                  value: el.productId,
                  label: el.translatedValue,
                  icon: getIcon[
                    el?.productKey.replaceAll("#", "").toLowerCase()
                  ],
                };
              })}
              handleChange={(key, value) => handleChange(key, value)}
              value={filters?.products}
              isMulti={true}
              className=" eg-bar-select "
              withIcon
            />
          </Col>
        )}
        {show && (
          <Col
            lg={2}
            xs={12}
            className="d-flex justify-content-lg-end  align-item-center   justify-content-center"
          >
            <div className="align-self-start pt-1">
              {showAddButton && <ParentBtn text={text} path={path} />}
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
}

export default ActionBar;
